<template>
  <span v-if="files.length > 0" class="help-button">
    <el-tooltip :content="label" placement="top">
      <base-button
        :size="size"
        type="info"
        outline
        icon
        :aria-label="label"
        @click="showModal = true"
      >
        <i class="fa fa-question-circle"></i>
        <span v-if="text" class="ml-1">{{ $t("TRAININGS.HELP") }}</span>
      </base-button>
    </el-tooltip>
    <training-files-modal
      :show="showModal"
      :title="label"
      :files="files"
      @close="showModal = false"
    />
  </span>
</template>

<script>
import TrainingFilesModal from "./TrainingFilesModal.vue";
import { HELP_CONTEXTS, helpContextI18nKey } from "@/constants/helpContexts";

/**
 * Bouton « ? » d'un écran : ouvre les vidéos et guides liés au sujet d'aide
 * (page Formation › Aide par écran). Invisible tant qu'aucun fichier n'y est lié.
 */
export default {
  name: "help-button",

  components: { TrainingFilesModal },

  props: {
    context: {
      type: String,
      required: true,
      validator: (value) => HELP_CONTEXTS.includes(value),
    },
    size: {
      type: String,
      default: "sm",
    },
    text: {
      type: Boolean,
      default: true,
      description: "Show the word « Aide » next to the icon",
    },
  },

  data() {
    return {
      showModal: false,
    };
  },

  computed: {
    files() {
      return this.$store.getters["trainings/helpForContext"](this.context);
    },
    label() {
      return this.$t("TRAININGS.HELP_FOR", {
        topic: this.$t(helpContextI18nKey(this.context)),
      });
    },
  },

  created() {
    // Help is a bonus: a failed load only hides the button.
    this.$store
      .dispatch("trainings/helpForContext", { context: this.context })
      .catch(() => {});
  },
};
</script>
